var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"formwaysBuilder"}}),_c('button',{staticClass:"btn btn-success mt-2",attrs:{"type":"button"},on:{"click":_vm.getSchema}},[_vm._v(" Save Form ")])])}
var staticRenderFns = []

export { render, staticRenderFns }